import { alpha, Toolbar, Typography, useEventCallback } from '@mui/material';
import { Fragment, ReactElement, useCallback, useMemo, useState } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { PmiButton } from 'shell/components/shared/button';
import { PracticesAssignOperatorCrumbs } from 'practice/constants/practice-crubs';
import TableCheckbox from 'shell/components/shared/table-checkbox';
import { useFormik } from 'formik';
import {
  FormPracticesAssignOperatorVM,
  PracticeSelectableVM,
} from 'practice/view-models/practices-assign';
import { Divider, Grid } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import OperatorList from 'front-office/components/shared/operator-list';
// import ServiceList from 'practice/components/shared/filter/filter-practice/list/service-list';
import { validationSchemaPracticesAssignOperator } from 'practice/constants/practice-research-validation';
import { headCellsPracticesAssign } from 'practice/constants/practi-assign-headcells';
import PmiTooltipError from 'shell/components/shared/tooltip-error';
import Filter from 'practice/components/shared/filter';
import { toast } from 'react-toastify';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import {
  FilterPersonVM,
  FilterPracticeVM,
  PracticeDataVM,
} from 'practice/view-models/practice-research';
import {
  CustumPracticeHttpResponseList,
  transformerPraticeList,
  transformPracticeSearchFiltersData,
} from 'practice/utils/practice-research-transform';
import { PracticeData } from 'shell/models/practice';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import NotificationAllert from 'shell/components/shared/notification-allert';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import TablePagination from 'shell/components/shared/table/table-pagination';
import { useUserProfile } from 'shell/hooks/use-user-profile';

const rowsPerPageOptions = [5, 10, 20, 50];

const PracticesAssignOperatorPage = (): ReactElement => {
  const [isForPersonSearch, setIsPersonSearch] = useState<boolean>(false);

  const [page, setPage] = useState<number>(0);

  const [rowsPerPage, setRowsPerPage] = useState<number>(10);

  const { userProfile } = useUserProfile();
  const authPerson = userProfile.datiLogin?.profile?.feature?.filtroPraticaServizioOperatore || '';

  const [practiceList, getPraticeList] = useHttpFetch<
    CustumPracticeHttpResponseList<PracticeData>,
    PracticeDataVM
  >(`${__PRACTICE_API_URL__}/pratiche`, {
    onBootstrap: false,
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
      data: {},
    },
    transformer: transformerPraticeList,
  });

  const list = ((practiceList.data as PracticeDataVM)?.list || []) as Array<PracticeSelectableVM>;

  const assignOperator = useHttpClient(
    `${__PRACTICE_API_URL__}/storico-operatori-pratica/nuova-assegnazione`,
    {
      options: {
        method: 'POST',
        data: {},
      },
    }
  );

  const onSubmitAssignOperator = useCallback(
    (values: FormPracticesAssignOperatorVM) => {
      (
        assignOperator({
          data: {
            listStoricoOperatorePratica:
              values.practices?.map((practice) => ({
                codiceEnte: practice.codiceEnte,
                tipoRegistro: practice.tipoRegistro,
                idAnnoPratica: practice.idAnnoPratica,
                progressivoPratica: practice.progressivoPratica,
              })) || [],
            codiceServizio: values.newService,
            codiceOperatore: values.newOperator,
            motivoCambioOperatore: values.reason,
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
      });
    },
    [assignOperator]
  );

  const getPraticeListData = useEventCallback(
    (dataFilter: OperationObject, pageNumber?: number, rowsPerPageNumber?: number) => {
      const queryParams = `${paginationListToQueryString({
        filters: dataFilter,
        orders: {},
        page: pageNumber || 0,
        rowsPerPage: rowsPerPageNumber || 10,
      })}`;

      (
        getPraticeList({
          url: `${isForPersonSearch ? '/persona' : ''}`,
          params: {},
          paramsSerializer: () => queryParams,
        }) as ResponsePromise<void>
      ).then(() => {
        setIsPersonSearch(false);
      });
    }
  );
  const formikContext = useFormik<FormPracticesAssignOperatorVM>({
    initialValues: {
      practices: [],
      newService: '',
      newOperator: '',
      reason: '',
    },
    validationSchema: validationSchemaPracticesAssignOperator,
    onSubmit: onSubmitAssignOperator,
  });

  const onSubmitPerson = useEventCallback((personFilters: FilterPersonVM) => {
    // effettuare ricerca pratiche per codice o nome e cognome
    const data = {
      codiceFiscale: { value: personFilters?.fiscalCode || '', operation: Operation.EQUALS },
      nome: { value: personFilters?.name || '', operation: Operation.EQUALS },
      cognome: { value: personFilters?.surname || '', operation: Operation.EQUALS },
    };
    setIsPersonSearch(true);
    getPraticeListData(data);
    formikContext.handleReset({});
  });

  const onSubmitFilterPractice = useEventCallback((values: FilterPracticeVM) => {
    const data = transformPracticeSearchFiltersData(values);

    const queryParams = `${paginationListToQueryString({
      filters: data,
      orders: {},
    })}`;

    getPraticeList({ params: {}, paramsSerializer: () => queryParams });
    formikContext.handleReset({});
  });

  const practicesBE: Array<PracticeSelectableVM> = useMemo(() => {
    const operations = list;
    if (!operations) {
      return [];
    }
    const checkedList: Array<PracticeSelectableVM> = operations.map((item) => {
      const isSelectedFunction = !!formikContext.values.practices?.find(
        (operation) => operation.pratice === item.pratice
      );
      const colorTop =
        item.isRed || item.isRedIsFlashes ? 'error' : item.isOrange ? 'warning' : 'success';

      return {
        ...item,
        notifications: (
          <Fragment>
            <NotificationAllert color={colorTop} isFlashes={item.isRedIsFlashes} />
            {item.isYellow ? (
              <div style={{ margin: '4px 0 0 0' }}>
                <NotificationAllert color="cdmBrandYellow" isFlashes />{' '}
              </div>
            ) : undefined}
          </Fragment>
        ),
        checked: isSelectedFunction,
      };
    });

    return checkedList;
  }, [list, formikContext.values.practices]);

  const onCheckPress = useCallback(
    (itemSelected) => {
      let practicesNew = formikContext.values.practices?.slice() || [];

      const isSelectedPractice = !!formikContext.values.practices?.find(
        (item) => item.pratice === itemSelected.pratice
      );

      if (isSelectedPractice) {
        practicesNew = practicesNew.filter(
          (operation) => operation.pratice !== itemSelected.pratice
        );

        formikContext.setFieldValue('practices', practicesNew);
        return;
      }

      practicesNew.push(itemSelected);
      formikContext.setFieldValue('practices', practicesNew);
    },
    [formikContext.setFieldValue, formikContext.values.practices]
  );

  const onSelectAll = useCallback(
    (selected) => {
      const functionalitiesNew = practicesBE
        .slice()
        .map((practice) => ({
          ...practice,
          checked: selected,
        }))
        .filter((item) => item.checked);

      formikContext.setFieldValue('practices', functionalitiesNew);
    },
    [formikContext.setFieldValue, practicesBE]
  );

  const handleChangeOperator = useCallback(
    (value) => {
      formikContext.setFieldValue('newOperator', value);
    },
    [formikContext.setFieldValue]
  );

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  return (
    <Fragment>
      <Breadcrumbs items={PracticesAssignOperatorCrumbs} />
      <div className="pmi-pt-4 pmi-pb-3 pmi-d-flex pmi-align-items-center pmi-justify-content-between">
        <Typography
          color="secondary.main"
          style={{
            fontSize: '26px',
          }}
        >
          Ricerca pratiche per assegnazione altro operatore
        </Typography>
      </div>
      <Filter
        onSubmitFilterPractice={onSubmitFilterPractice}
        onSubmitPerson={onSubmitPerson}
        practiceLength={practicesBE?.length || 0}
        authPerson={authPerson}
      />
      <form onSubmit={formikContext.handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PmiTitleDivider>Nuova assegnazione:</PmiTitleDivider>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          {/* </Grid>
          <Grid item xs={12} md={6}>
            <ServiceList
              required
              value={formikContext.values.newService || ''}
              onChange={handleChangeService}
              error={formikContext.touched.newService && Boolean(formikContext.errors.newService)}
            />
          </Grid> */}
          <Grid item xs={12} md={6}>
            <OperatorList
              required
              operatorType={'0'}
              value={formikContext.values.newOperator || ''}
              onChange={handleChangeOperator}
              error={formikContext.touched.newOperator && Boolean(formikContext.errors.newOperator)}
            />
          </Grid>
          <Grid item xs={12}>
            <PmiTextField
              label="Motivo Assegnazione Operatore"
              aria-label="Motivo Assegnazione Operatore"
              id="reason"
              fullWidth
              multiline
              rows={5}
              inputProps={{
                maxLength: '100',
              }}
              value={formikContext.values?.reason || ''}
              onChange={(event) => {
                formikContext.setFieldValue('reason', event?.target.value);
              }}
              error={formikContext.touched.reason && Boolean(formikContext.errors.reason)}
              helperText={formikContext.errors.reason}
            />
          </Grid>
          <Grid item xs={12}>
            <PmiTooltipError
              show={Boolean(formikContext.errors.practices)}
              message={formikContext.errors.practices}
            >
              <PmiButton type="submit" variant="outlined" color="cdmBrandThird">
                Assegna ad altro operatore
              </PmiButton>
            </PmiTooltipError>
          </Grid>
          {practiceList.data ? (
            practicesBE?.length > 0 ? (
              <>
                <Grid item xs={12}>
                  <Toolbar
                    sx={{
                      pl: { sm: 2 },
                      pr: { xs: 1, sm: 1 },
                      ...((formikContext.values.practices?.length || 0) >= 0 && {
                        bgcolor: (theme) =>
                          alpha(
                            theme.palette.cdmBrandThird.main,
                            theme.palette.action.activatedOpacity
                          ),
                      }),
                    }}
                  >
                    <Typography
                      sx={{ flex: '1 1 100%' }}
                      color="inherit"
                      variant="subtitle1"
                      component="div"
                    >
                      {formikContext.values.practices?.length || 0}{' '}
                      {formikContext.values.practices?.length === 1 ? 'selezionato' : 'selezionati'}
                    </Typography>
                  </Toolbar>
                  <TableCheckbox
                    minWidth={600}
                    head={headCellsPracticesAssign}
                    body={(practicesBE || []).slice(startIndex, endIndex)}
                    onCheckPress={onCheckPress}
                    onSelectAll={onSelectAll}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TablePagination
                    rowsPerPageOptions={rowsPerPageOptions}
                    count={practicesBE?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(newPage) => setPage(newPage)}
                    onRowsPerPageChange={(number) => {
                      setRowsPerPage(number);
                    }}
                  />
                </Grid>
              </>
            ) : (
              <Typography color="secondary.main">
                Nessun elemento trovato con la ricerca effettuata.
              </Typography>
            )
          ) : undefined}
        </Grid>
      </form>
    </Fragment>
  );
};

PracticesAssignOperatorPage.displayName = 'Practices Assign Operator Page component';

export default PracticesAssignOperatorPage;
